import _silent from "@goldfishjs/utils/lib/silent";
import _find from "@goldfishjs/utils/lib/find";
import { upFirst } from "../common/utils";
import { clients } from "./clients";
import { clientName, detectType, platformType } from "../common/constants";
function setDefaultWebH5(env) {
  if (!env.client) {
    env.client = clientName.webH5;
  }
  if (!env.platform) {
    env.platform = platformType.web;
  }
  var hasTrue = false;
  for (var key in env.appEnv) {
    if (env.appEnv[key]) {
      hasTrue = true;
      break;
    }
  }
  if (!hasTrue) {
    env.appEnv.isWebH5 = true;
  }
}
function parseAppAndUA(clientsParam, info) {
  var targetClient = _find(clientsParam, function (client) {
    return client.regs.every(function (reg) {
      return reg.test(info);
    });
  });
  var env = {};
  var appEnv = Object.keys(clientName).reduce(function (result, clientNameKey) {
    var name = clientName[clientNameKey];
    var key = "is".concat(name.split('_').map(upFirst).join(''));
    result[key] = name === (targetClient === null || targetClient === void 0 ? void 0 : targetClient.name);
    if (result[key]) {
      env.client = name;
    }
    return result;
  }, {});
  env.appEnv = appEnv;
  env.platform = targetClient === null || targetClient === void 0 ? void 0 : targetClient.type;
  return env;
}
function getEnvFromSystemInfo() {
  var info = _silent(function () {
    return my.getSystemInfoSync();
  })();
  if (!info || !info.app) {
    return;
  }
  var localClients = clients.filter(function (client) {
    return client.detectType === detectType.app;
  });
  return parseAppAndUA(localClients, info.app);
}
function getEnvFromUA() {
  var info = _silent(function () {
    var env = window;
    return env.navigator.userAgent;
  })();
  if (!info) {
    return;
  }
  var localClients = clients.filter(function (client) {
    return client.detectType === detectType.ua;
  });
  var env = parseAppAndUA(localClients, info);
  // Since we can visit the `window`, we can also return the pure H5 environment
  setDefaultWebH5(env);
  return env;
}
function parseApp(app) {
  var normalizeClientName = function normalizeClientName(str) {
    return str.replace(/_/g, '').toLocaleLowerCase();
  };
  var normalizedApp = normalizeClientName(app);
  var client = undefined;
  var platform = undefined;
  var appEnv = Object.keys(clientName).reduce(function (result, clientNameKey) {
    var name = clientName[clientNameKey];
    var key = "is".concat(name.split('_').map(upFirst).join(''));
    result[key] = normalizeClientName(name) === normalizedApp;
    if (result[key]) {
      client = name;
      platform = name.match(/mp_web|mp|web/)[0];
    }
    return result;
  }, {});
  return {
    appEnv: appEnv,
    client: client,
    platform: platform
  };
}
function getEnvFromUrl() {
  // The value of `__app__` is MpAlipayHK, WebAlipay and so on.
  var app = _silent(function () {
    return (window.location.search.match(/[?&]__app__=([^?&=]+)/) || [])[1];
  })();
  var env = app ? parseApp(app) : undefined;
  if (env) {
    // Since we can visit the `window`, we can also return the pure H5 environment
    setDefaultWebH5(env);
  }
  return env;
}
function getEnvFromLocalStorage() {
  // The value of `__app__` is MpAlipayHK, WebAlipay and so on.
  var app = _silent(function () {
    return localStorage.getItem('__app__');
  })();
  var env = app ? parseApp(app) : undefined;
  if (env) {
    // Since we can visit the `window`, we can also return the pure H5 environment
    setDefaultWebH5(env);
  }
  return env;
}
export default function getEnv() {
  var env;
  if (typeof my !== 'undefined') {
    env = getEnvFromSystemInfo();
    if (env) {
      return env;
    }
  }
  env = getEnvFromUrl();
  if (env) {
    return env;
  }
  env = getEnvFromLocalStorage();
  if (env) {
    return env;
  }
  env = getEnvFromUA();
  if (env) {
    return env;
  }
  // It is H5 environment, and use the pure H5.
  if (typeof window !== 'undefined') {
    var app = 'WebH5';
    env = parseApp(app);
    if (env) {
      return env;
    }
  }
  return;
}